<template>
    <div class="cat-table" v-if="tableData.length > 0">
        <div class="pb-3" v-if="customId !== 'tableCS' && fundingICData && fundingICData.length > 0">
            <span class="fw-bold align-top me-1 pt-1">Filter By: </span>
            <BDropdown text="Funding ICs" variant="outline-secondary" id="fundingIcDropdown" class="fundingIcDropdown" size="sm" autoClose="outside" v-on:show="highlightDropdown" v-on:hide="onDropdownHide($event)">
                <BDropdownItem href="#" @click="keepDropDownOpen = true">
                    <input type="checkbox" v-model="selectAll" class="me-2" @click="selectAllFundingICs(); getChartData('all');" id="chkALL"><label for="chkALL">ALL ICs</label>
                </BDropdownItem>
                <template v-for="pt in fundingICData">
                    <BDropdownItem href="javascript:void(0)" @click="keepDropDownOpen = true;"><input type="checkbox" class="me-2" @click="checkCheckbox();  getChartData('opt');" v-model="icFilter" :id="'chk' + pt" :value="pt"><label :for="'chk' + pt">{{ pt }}</label></BDropdownItem>
                </template>
            </BDropdown>

        </div>
        <div class=" position-relative">
            <div class="scroll-table-container b-table-sticky-header">
                <BTable sticky-header="450" striped v-if="!isFilteringData" :items="filteredTableData" :fields="columns" head-variant="dark"
                    :sortB="sortField"
                    :sortDesc="sortDir"
                    :current-page="tablePageNo"
                    :per-page="pageSize"
                    :stacked="stacked"
                    class="bg-white w-100"
                    table-class="funding-table"
                    :busy.sync="isBusy"
                    :filter="customId === 'tableCS' ? filterText : ''"
                    :showEmpty="false"
                    emptyText=""
                    :filterable="filterOnColumns"
                    select-mode="single"
                    thead-class="table-header"
                    :ref="'tbl_' + customId"
                    selectable
                    @row-clicked="onRowSelected"
                    :id="customId"
                    @context-changed="hideLoader"
                >
                    <template #head()="data">
                        <div class="sr-only">report</div>
                        <div><span v-html="data.label"></span>&nbsp;<a v-if="data.field.footnoteID !== 0 && data.field.footnoteID !== ''" @click.prevent="goToByScroll('#footnote-'+ data.field.footnoteID)"><sup>{{data.field.footnoteID}}</sup></a></div>
                        <div class="sort-icons"></div>
                    </template>
                    <template #cell(disease)="data">
                        <span>{{data.value.label}} <a v-if="data.value.footNoteNum && data.value.footNoteNum > 0" href @click.prevent="goToByScroll('#footnote-'+ data.value.footNoteNum)"><sup>{{data.value.footNoteNum}}</sup></a></span>
                    </template>
                    <template #cell(project_Number)="data">
                        <b-link
                            :href="getURL(data)"
                            target="_blank"
                            v-if="getURL(data)"
                            class="link"
                        >
                            {{data.value}}
                        </b-link>
                        <span v-else>{{data.value}}</span>
                    </template>
                    <template #cell(report_Id)="data">
                    <!--<b-link class="collapsed-link" v-b-toggle :href="'#frr_row' + data.value"   @click.prevent="onRowSelected(data)"><i class="fas fa-angle-right"></i></b-link>-->
                        <span :id="'tbl_row_id_' + data.item.report_Id + '_' + data.index" class="collapsed-link"><i class="fas fa-angle-right"></i></span>
                        <template v-if="data.item.max_Version && data.item.max_Version !== data.item.version"><span class="text-danger fw-bold">*</span></template>
                    </template>
                    <template #cell(report_Title)="data">
                        {{data.value}}
                        <BCollapse :id="'tbl_row_' + data.item.report_Id + '_' + data.index" class="nested-table-container mt-3">
                            <div v-if="drillDownLoading[data.index]" class="loader"></div>
                            <b-table 
                                :items="nestedTableData[data.index]"
                                :fields="nestedTableColumns"
                                :stacked="stacked"
                                v-if="!drillDownLoading[data.index] && !isCollapsed[data.index] && nestedTableData[data.index]"
                                :responsive="responsive">
                                <template #cell()="data">
                                    <template v-for="(dispData, ind) in data.value">
                                        <template v-if="dispData">
                                            {{dispData.title}}<template v-if="data.field.key == 'ic' || data.field.key == 'mechanism'"><br /></template><template v-else-if="ind < data.value.length - 1">, </template>
                                        </template>
                                    </template>
                                </template>
                            </b-table>
                            <span v-if="!drillDownLoading[data.index] && drillDownErr[data.index]">
                                <BAlert :model-value="true" variant="danger">{{ drilldownErrMsg }}</BAlert>
                            </span>
                        </BCollapse>
                    </template>
                    <template #cell(variable)="data">
                        <template v-for="(dispData, ind) in data.value">
                            <template v-if="dispData">
                                {{dispData.title}}<template v-if="ind < data.value.length - 1"><template v-if="customId === 'catalogTable'"><br /></template><template v-else>, </template></template>
                            </template>
                        </template>
                    </template>

                    <template #cell(topic)="data">
                        <template v-for="(dispData, ind) in data.value">
                            <template v-if="dispData">
                                {{dispData.title}}<template v-if="ind < data.value.length - 1"><template v-if="customId === 'catalogTable'"><br /></template><template v-else>, </template></template>
                            </template>
                        </template>
                    </template>
                    <template #cell(link)="data">
                        <b-link :href="data.value" class="btn btn-secondary px-1 text-nowrap"><i class="fas fa-download text-nowrap"></i>&nbsp;Download</b-link>
                    </template>
                    <template #cell(version)="data">
                        <b-link href @click.prevent="downloadFile(data.item)" class="btn btn-secondary px-1 text-nowrap"><i class="fas fa-download text-nowrap"></i>&nbsp;Download</b-link>
                    </template>
                    <template #cell()="data">
                        <span class="stacked-header fw-bold">{{ data.field.label }}: </span>
                        <template v-if="data.field.type === 'currency'">
                            <template v-if="data.field.key === 'amount'">
                                {{data.value}}
                            </template>
                            <template v-else-if="data.value  === 0 && showZeroCategories.indexOf(data.item.disease.label) === -1">
                                <a href @click.prevent="" v-b-tooltip.hover title="The minimum reporting threshold for a specific disease/condition is $500,000. Reporting of $0 does not indicate that no research is being conducted.">*</a>
                            </template>
                            <template v-else-if="!data.value && showZeroCategories.indexOf(data.item.disease.label) === -1">
                                <a href @click.prevent="" v-b-tooltip.hover title="Indicates a new category. Funding support data not available prior to the initial year reported.">+</a>
                            </template>
                            <template v-else-if="data.field.isEstimated">{{data.value}}</template>
                            <template v-else>
                                <template v-if="data.value === 0 && showZeroCategories.indexOf(data.item.disease.label) !== -1">${{data.value}}</template>
                                <b-link class="link" @click.prevent="drilldown(data)" v-else>{{data.value}}</b-link>
                            </template>
                        </template>
                        <template v-else>
                            <template v-if="!data.value">
                                -
                            </template>
                            <template v-else>
                                {{data.value}}
                            </template>
                        </template>
                    </template>
                </BTable>
            </div>
        </div>
        <span v-if="icFilter && icFilter.length === 0">No data found</span>
    </div>
    <div  class="cat-table position-relative scroll-table-container" v-else-if="!isBusy">
        <BTable sticky-header="100%" striped  :fields="columns" head-variant="dark"
            :sortB="sortField"
            :sortDesc="sortDir"
            :current-page="tablePageNo"
            :per-page="pageSize"
            :stacked="stacked"
            :responsive="responsive"
            table-class="funding-table"
            :busy.sync="isBusy"
            :filter="filterText"
            :showEmpty="true"
            :emptyText="'No data matching your criteria.'"
            :filter-included-fields="filterOnColumns"
            select-mode="single"
            thead-class="table-header"
            :ref="'tbl_' + customId"
            selectable
            @row-clicked="onRowSelected"
            :id="customId"
            @context-changed="hideLoader"
        ><template #head()="data">
                <div class="sr-only">report</div>
                <div><span v-html="data.label"></span> <a v-if="data.field.footnoteID !== 0 && data.field.footnoteID !== ''" @click.prevent="goToByScroll('#footnote-'+ data.field.footnoteID)"><sup>{{data.field.footnoteID}}</sup></a></div>
                <div class="sort-icons"></div>
            </template>
        </BTable>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { BaseURL, GET_SETTING_SUB_PATH } from "@/shared/config.js";
import * as axios from 'axios';
import bus from '@/shared/event-bus.js';
import { toRaw  } from 'vue'
import { SERVICE_UNAVAILABLE_ERROR_MSG } from "@/shared/config.js";

export default {
    name: 'vTable',
    inject: ["mq"],
    props: {
        columns: {
            type: Array
        },
        tableData: {
            type: Array,
            required: true
        },
        fundingICData: {
            required: false
        },
        pageSize: {
            required: true
        },
        isBusy: {
            type: Boolean
        },
        isDrilldown: {
            type: Boolean
        },
        customId: {
            type: String
        },
        currentFyRange: {
            required: false
        },
        tablePageNo: {
            required: false
        },
        filterOnColumns: {
            required: false
        },
        filterText: {
            required: false
        },
        nestedTableColumns: {
            required: false
        },
        nestedTableData: {
            required: false
        },
        tableName: {
            required: true
        }
    },
    data: function () {
        return {
            icFilter: this.fundingICData,
            sortDir: true,
            sortField: null,
            footNoteClick: false,
            downLoadLoader: false,
            colsPerView: 9,
            drillDownLoading: {},
            drillDownErr: {},
            isCollapsed: {},
            showZeroCategories:[],
            isFilteringData: false,
            selectAll: true,
            drilldownErrMsg: SERVICE_UNAVAILABLE_ERROR_MSG,
            keepDropDownOpen: false,
            items: [
          { heading1: 'table cell', heading2: 'table cell', heading3: 'table cell' },
          { heading1: 'table cell', heading2: 'table cell', heading3: 'table cell' },
          { heading1: 'table cell', heading2: 'table cell', heading3: 'table cell' },
          { heading1: 'table cell', heading2: 'table cell', heading3: 'table cell' },
          { heading1: 'table cell', heading2: 'table cell', heading3: 'table cell' },
          { heading1: 'table cell', heading2: 'table cell', heading3: 'table cell' },
          { heading1: 'table cell', heading2: 'table cell', heading3: 'table cell' },
          { heading1: 'table cell', heading2: 'table cell', heading3: 'table cell' },
          { heading1: 'table cell', heading2: 'table cell', heading3: 'table cell' },
          { heading1: 'table cell', heading2: 'table cell', heading3: 'table cell' },
          { heading1: 'table cell', heading2: 'table cell', heading3: 'table cell' },
          { heading1: 'table cell', heading2: 'table cell', heading3: 'table cell' }
        ]
        };
    },
    computed: {
        ...mapGetters([
            'appVersion',
        ]),
        stacked () {
            const stackedBreakpoints = ['sm', 'xs'];

            return stackedBreakpoints.includes(this.mq.current);
        },
        responsive () {
            const responsiveBreakpoints = ['md', 'lg', 'xl', 'xxl'];

            return responsiveBreakpoints.includes(this.mq.current);
        },
        filteredTableData () {
            let filteredData,
                icFilters = toRaw(this.icFilter);
            
            if (this.customId === 'tableCS-drilldown') {
                this.isFilteringData = true;
                filteredData = _.filter(this.tableData, function (item) {
                    return icFilters.indexOf(item.ic) !== -1;
                });
                setTimeout(() => {
                    this.isFilteringData = false;
                }, 1);
                this.addSortIcons();
                bus.$emit('table:filtered', filteredData, true);
                return filteredData;
            }
           
            this.addSortIcons();
            bus.$emit('table:filtered', this.tableData, false);
            return this.tableData;
        },
    },
    watch: {
        '$parent.activeColumn': function (val) {
            var colIndex = 0,
                headerObj;

            $(".highlight").removeClass("highlight");
            if (val) {
                headerObj = _.filter($("#tableCS th"), function (item, i) {
                    if ($(item).find('div').html()) {
                        if ($(item).find('div').html().toLowerCase().indexOf(val.toLowerCase()) !== -1 && colIndex === 0) {
                            colIndex = i + 1;
                            return  true;
                        }
                    }
                    return false;
                });

                $("#tableCS td:nth-child("+ colIndex +")").addClass("highlight");
                $(headerObj).addClass("highlight");
            }
        },
        tableData: function () {
            this.addSortIcons();
        }
    },
    mounted () {
        var self = this;

        if (this.tableName === 'categoricalSpending') {
            this.getSpecialCategories();
        }
        bus.$on('drilldowndata:loaded', function (isDataAvailable, dataIndex) {
            self.drillDownLoading[dataIndex] = false;
            if (!isDataAvailable) {
                self.drillDownErr[dataIndex] = true;
            }
            if (!self.isCollapsed) {
                self.isCollapsed = [];
            }
            self.isCollapsed[dataIndex] = false;
        });
        bus.$on('set:tableSort', () => {
            this.addSortIcons();
        }) 
    },
    methods: {
        getChartData (param) {
            setTimeout(async () => {
                bus.$emit('load:chartDataByFunding', this.icFilter);
            }, 401);
        },
        checkCheckbox () {
            setTimeout(() => {
                if (this.icFilter.length > 0 && this.icFilter.length !== this.fundingICData.length ) {
                    $("#chkALL")[0].indeterminate = true; 
                } else {
                    $("#chkALL")[0].indeterminate = false; 
                    if (this.icFilter == 0) {
                        $("#chkALL")[0].checked = false;
                        this.selectAll = false;
                    } else {
                        $("#chkALL")[0].checked = true;
                        this.selectAll = true;
                    }
                }
            }, 1);
        },
        highlightDropdown () {
            $(".fundingIcDropdown").addClass('show');
        },
        onDropdownHide(bvEvent, eve) {
            if (this.keepDropDownOpen) {
                bvEvent.preventDefault();
                this.keepDropDownOpen = false;
            } else {
                $(".fundingIcDropdown").removeClass('show');
            }
        },
        selectAllFundingICs () {
            this.keepDropDownOpen = true;
            if (this.selectAll) {
                this.icFilter = [];
            } else {
                this.icFilter = this.fundingICData;
            }
        },
        addSortIcons () {
            setTimeout(() => {
                $(".scroll-table-container div.table-bg-row").remove();
                let thEle;
                _.forEach($(".b-table-sort-icon"), (ele) => {
                    thEle = $(ele).parents('th');
                    thEle.find('.sort-icons').append(ele);
                    thEle.find('.b-table-sort-icon').html('').append(`<i class="fas fa-angle-up header__sort-icon-up svg"></i><i class="fas fa-angle-down header__sort-icon-down svg"></i>`);
                });
                let offsetPos =  $(".scroll-table-container .table").position() ?  $(".scroll-table-container .table").position().top : 0;
                let colHeight = $(".scroll-table-container .table thead tr:first").outerHeight();
                $(".scroll-table-container").append('<div class="table-bg-row" style="height: '+colHeight+'px; margin-top: ' + offsetPos+'px;"></div>');
            }, 501);
        },
        getSpecialCategories() {
            var xhr;

            xhr = new XMLHttpRequest();
            var url,
                requestType = 'GET',
                $this = this;

            url = BaseURL + GET_SETTING_SUB_PATH + 'REPORT_SHOW_0_AMOUNT_CATEGORIES';

            xhr.open(requestType, url, true);

            xhr.onload = function () {
                if (xhr.status === 200) {
                    $this.showZeroCategories = xhr.responseText ? xhr.responseText.split(";") : '';
                }
            };
            xhr.send();

        },
        selectThisRow (rowId) {
            if (this.columns && this.columns.length > 0) {
                if (rowId) {
                    this.$refs['tbl_' + this.customId].selectRow(rowId);
                }
            }
        },
        onRowSelected (items, index) {
            switch (this.tableName) {
                case 'categoricalSpending':
                    this.$parent.setChartData(items.disease.label);
                    break;
                case 'frequentlyRequestedRpts':
                case 'catalogRpts':
                    if (items && items.item && items.item.report_Id) {
                        this.getDrillDownData(items.item, items.index, false);
                    } else {
                        this.getDrillDownData(items, index, true);
                    }
                    break;
            }
        },
        getDrillDownData (dataItem, dataIndex, isRowClicked) {
            var isExpanded = $('#tbl_row_id_' + dataItem.report_Id + '_' + dataIndex).hasClass("expanded"),
                $this = this;

            if (!isExpanded) {
                if (!this.drillDownLoading) {
                    this.drillDownLoading = [];
                }
                this.drillDownLoading[dataIndex] = true;
            } else {
                this.isCollapsed[dataIndex] = true;
            }
            this.drillDownErr[dataIndex] = false;
            if (isRowClicked) {
                $('#tbl_row_' + dataItem.report_Id + '_' + dataIndex).toggle();
                $('#tbl_row_id_' + dataItem.report_Id + '_' + dataIndex).toggleClass('expanded');
            }
            setTimeout(async () => {
                bus.$emit('load:drilldowndata', dataItem, dataIndex);
            }, 401);
        },
        async downloadFile (data) {
                var winOrigin = window.location.origin,
                    downloadButton = document.createElement('a'),
                    filePath, fileName;

                const response = await axios.get(encodeURI(`${BaseURL}/api/download/getFileName?rid=${data.report_Id}&ver=${data.version}`));
                if (response && response.status === 200) {
                    filePath = response.data;
                    fileName = filePath.split('/')[filePath.split('/').length - 1];

                    if (filePath.indexOf('.xlsx') !== -1 || filePath.indexOf('.ppt') !== -1) {
                        downloadButton.setAttribute('href', filePath);
                        downloadButton.setAttribute('download', fileName);

                        downloadButton.setAttribute('id','export-download');
                        downloadButton.setAttribute('style','opacity: 0;');

                        document.body.appendChild(downloadButton);
                        downloadButton.click();
                        downloadButton.parentElement.removeChild(downloadButton);
                    } else {
                        if (filePath.indexOf('http') !== -1) {
                            window.location.href = filePath;
                        } else {
                            window.location.href = (winOrigin.indexOf('localhost') !== -1 ? 'https://report-stage.od.nih.gov' : winOrigin) + response.data;
                        }
                    }
                }
                return false;
        },
        getURL (data) {
            let column = data.field;

            if (data.item[column.urlField] && data.item[column.urlField] !== "" && data.item[column.urlField].toString().trim() !== "0") {
                return this.$parent.baseReporterURL + (column.link ? column.link.replace('{{' + column.urlField + '}}', data.item[column.urlField]) : '');
            }
            return '';
        },

        drilldown (category) {
            this.$parent.setChartData(category.item.disease.label);
            this.$parent.loadDataDrilldown({
                column: category.field,
                category: category.item.disease.label
            }, category.index);

        },

        goToByScroll (id){
            var self = this;

            self.footNoteClick = true;
            $('html,body').animate({scrollTop: $(id).offset().top},'slow',function () {
                self.footNoteClick = false;
            });
            return false;
        },

        hideLoader () {
            this.$nextTick(() => {
                this.$parent.hideLoader();
            });
        }
    }
};
</script>

<style lang="scss">
    @import '@/scss/variables.scss';

    .b-table-selection-column {
        display: none;
    }
    .b-table-empty-slot {
        td {
            font-weight: bold;
            text-align: center;
        }
    }
    #dashboard-tables {
        .isBusy {
            table.b-table {
                opacity: 0.6;
            }
        }
    }
    .export-help-btn {
        position: relative;
        border-radius: 4px;
        display: inline-block;
        vertical-align: top !important;
        .help {
            margin-left: 15px;
            vertical-align: top;
        }
        .help-icon {
            height: 25px;
            width: 25px;
            display: inline-block;
            margin-left: 5px;
            margin-top: 5px;

            .color1 {
                fill: #015496;
            }
            .color2 {
                fill: #FFF;
            }
        }
    }

    .cat-table {
        min-height: 250px;
        th {
            padding: 0.5rem 0 0.5rem 0.5rem;
            font-weight: normal;
            background-color: $blue !important;
            vertical-align: middle !important;
            color: $white !important;
            word-break: normal !important;
            border: none !important;
            position: relative;
            div {
                &.d-inline-flex {
                    display: inline !important;
                }
                div {
                    padding-right: 12px;
                }
            } 
        }
        td {
            padding: 0.5rem 0 0.5rem 0.5rem;
            &.highlight {
                background-color: #dee2e6;
            }
            a.link {
                text-decoration: underline;
            }
        }
        .diseaseCol {
            word-break: break-word;
            width: 20%;
            span {
                 white-space: pre-wrap;
            }
            &:before {
                 white-space: pre-wrap;
            }
        }
        .b-table-sort-icon {
            width: 16px;
            position: relative;

            svg {
                width: 16px !important;
                position: absolute;
                top:-5px;
                opacity: 0.5;
            }
            .header__sort-icon-down {
                top: 5px;
            }
            &.sorted-asc {
                .header__sort-icon-down {
                    opacity: 0.5;
                }
                .header__sort-icon-up {
                    opacity: 1;
                }
            }
            &.sorted-desc {
                .header__sort-icon-down {
                    opacity: 1;
                }
                .header__sort-icon-up {
                    opacity: 0.5;
                }
            }
        }

        .b-table-selection-column {
            display: none;
        }
        .sort-icons {
            position: absolute;
            bottom:32px;
            right: 12px;
        }
        
    }
    table.funding-table {
        .stacked-header {
            display: none;
        }
        &.b-table-stacked {
            .stacked-header {
                display: inline-block;
            }
        }
        tr {
            &.selected.table-primary {
                td {
                    background-color: #c0cfde;
                }
            }
        }
        th, td {
            padding: 0.5rem 0.2rem 0.5rem;
            sup {
                text-decoration: underline;
            }
            .collapsed-link {
                display: block;
                font-weight: bold;
                &.expanded {
                    transform: rotate(90deg);
                    width: 25px !important;
                }
            }
        }
        .b-table-selection-column {
            display: none !important;
        }
    }

    .nested-table-container {
        min-height: 100px;
        // height: 100%;
        position: relative;
        color: #fff;
        .loader {
            top: 25px;
        }
        .table {
            td {
                background-color: #fff !important;
                color: #000 !important;
            }
        }
    }

    .fundingIcDropdown {
    
        z-index: 1002;
        ul {
            height: 150px;
            overflow: auto;
        }
        label, input {
            cursor: pointer;
        }
        &.show {
            z-index: 1004;
        }
    }

    .table-bg-row {
        position: absolute;
        background-color: #1f558a !important;
        top: 0;
        z-index: 1;
        width: calc(100% - 15px);
    }
</style>



